(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceAddOnListController', ServiceAddOnListController);

    ServiceAddOnListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'ServiceAddOn', 'ServiceAddOnCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService'];

    function ServiceAddOnListController($scope, $state, ParseLinks, AlertService, ServiceAddOn, ServiceAddOnCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService) {


        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.newServiceAddOnClick = newServiceAddOnClick;
        vm.searchKeyPress = searchKeyPress;


        vm.editServiceAddOn = editServiceAddOn;
        vm.deleteServiceAddOn = deleteServiceAddOn;
        vm.searchServiceAddOns = search;
        vm.searchKeyPress = searchKeyPress;
        vm.newServiceAddOn = newServiceAddOn;
        vm.clearSearch = clearSearch;


        loadAll_paging();

        function loadAll_paging() {


            if (pagingParams.search) {
                ServiceAddOnCustom.getAllCompanyServiceAddOns().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ServiceAddOnCustom.getAllCompanyServiceAddOns().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {

                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceAddOns = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function search() {

            loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();

        }

        function newServiceAddOnClick() {

            var result;

            // result = Principal.hasSpecialFeatureAccess("ServiceAddOnCode");
            // if (!result) {
            //     DialogService.showAlert("عدم دسترسی","برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
            //     return;
            // }

            $state.transitionTo('supplierPanel.newServiceAddOn');

        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function editServiceAddOn(serviceAddOn) {
            $state.go('supplierPanel-v2.editServiceAddOn', {id: serviceAddOn.id});
        }

        function deleteServiceAddOn(serviceAddOn) {
            console.log(serviceAddOn)

            function onSuccess() {
                loadAll_paging()
            }
            function onError() {

            }

            ServiceAddOnCustom.deleteServiceAddOns(serviceAddOn.id).delete({}, onSuccess, onError);
        }

        function newServiceAddOn() {
            var result;

            // result = Principal.hasSpecialFeatureAccess("ServiceAddOnCode");
            // if (!result) {
            //     DialogService.showAlert("عدم دسترسی","برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
            //     return;
            // }
            $state.go('supplierPanel-v2.newServiceAddOn');
        }

        function clearSearch() {
            vm.searchQuery = null;
            search();
        }

    }
})();
